import React from 'react';

import Modal from 'react-modal';

const ModalImage = ({ isOpen, onClose, src }) => {
  return (
    <Modal isOpen={isOpen} className="demolink-modal-image">
      <div className="modal-video-body">
        <div className="modal-video-inner">
          <div className="modal-video-movie-wrap">
            <button className="modal-video-close-btn" onClick={onClose}>
              x
            </button>
            <img src={src} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalImage;
